export interface CategorySavingsSplitInterface<T> {
  categoryValue: string | null;
  visible: T[];
}

export function splitCategorySavings<T>(
  items: T[] | null | undefined,
  isMarker: (item: T) => boolean,
  getValue: (item: T) => string | null
): CategorySavingsSplitInterface<T> {
  if (!items || items.length === 0) {
    return {categoryValue: null, visible: []};
  }
  const markerIndex: number = items.findIndex(isMarker);
  if (markerIndex < 0) {
    return {categoryValue: null, visible: items};
  }
  return {
    categoryValue: getValue(items[markerIndex]),
    visible: items.slice(0, markerIndex).concat(items.slice(markerIndex + 1))
  };
}
